import {Component, OnDestroy, OnInit} from '@angular/core';
import {BaseComponent} from '../core/base.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {HeaderService} from '../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {AuthService} from '../core/security/auth.service';
import {ModulesEnum} from '../core/security/modules.enum';
import {RolesEnum} from '../core/security/roles.enum';
import {MenuModel} from '../core/models/menu.model';
import {DateTime} from 'luxon';
import {CurrentUser} from '../api/models/current-user';
import { NgFor, NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: true,
    imports: [
        NgFor,
        NgIf,
        RouterLink,
        NgClass,
    ],
})
export class HomeComponent extends BaseComponent implements OnInit, OnDestroy {

  public hasSettingsAccess = false;
  public hasAnalyticsAccess = false;

  currentDateString: string;
  currentCompanyName: string;
  dayGreetings: string;
  showLoading = true;
  apps: MenuModel[] = [];

  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title, authService: AuthService, private router: Router) {
    super(route, headerService, titleService, authService);

    this.headerService.hideSideMenu();

    this.hasSettingsAccess = (
      this.authService.userHasPackage(ModulesEnum.AccountRolesModule)
      || this.authService.userHasPackage(ModulesEnum.AccountUsersModule))
      && this.authService.userHasPermission([
        RolesEnum.AccountUsers_View, RolesEnum.AccountUsers_Edit, RolesEnum.AccountUsers_Delete,
        RolesEnum.AccountRoles_View, RolesEnum.AccountRoles_Edit, RolesEnum.AccountRoles_Delete,
      ]);

    this.hasAnalyticsAccess = (
      this.authService.userHasPackage(ModulesEnum.ActivityDashboardModule)
      || this.authService.userHasPackage(ModulesEnum.CallLogsModule))
      && this.authService.userHasPermission([
        RolesEnum.ActivityDashboard_View, RolesEnum.ActivityDashboard_Edit, RolesEnum.ActivityDashboard_Delete,
        RolesEnum.CallLogs_View, RolesEnum.CallLogs_Edit, RolesEnum.CallLogs_Delete,
      ]);
  }

  ngOnInit() {
    super.ngOnInit();
    const localTime = DateTime.local();
    this.currentDateString = localTime.toFormat('EEEE, MMM d, y');
    const currentHour = localTime.hour;
    if (currentHour < 12) {
      this.dayGreetings = 'Good morning';
    } else if (currentHour < 18) {
      this.dayGreetings = 'Good afternoon';
    } else {
      this.dayGreetings = 'Good evening';
    }

    this.headerService.hideSideMenu();

    this.apps = this.headerService.getUserApps().filter(x => !x.forceHideApp);
    const menuItems = this.headerService.getUserSideMenu();
    this.showLoading = true;
    let foundActiveMenu = false;
    if (menuItems.length > 0) {
      for (const menuItem of menuItems) {
        if (!menuItem.url.startsWith('/forbidden')) {
          foundActiveMenu = true;
          this.router.navigateByUrl(menuItem.url);
          break;
        }
      }
      if (!foundActiveMenu) {
        const firstApp = menuItems[0];
        console.log('firstApp', firstApp);
        this.router.navigateByUrl(firstApp.url);
      }
    } else {
      this.showLoading = false;
    }
  }

  onCurrentUserChanged(user: CurrentUser) {
    super.onCurrentUserChanged(user);

    this.currentCompanyName = user?.customerProfileName;
  }

  showPopup(menu: MenuModel) {
    if (menu.description) {
      menu.showPopup = true;
    }
  }

  hidePopup(menu: MenuModel) {
    menu.showPopup = false;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (!this.headerService.isMobileView.getValue()) {
      this.headerService.showSideMenu();
    }
  }
}
